import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Phone } from "@phosphor-icons/react";
import { toast } from "sonner";

const fmt = (s) => new Date(s.length <= 10 ? `${s}T09:00` : s).toLocaleString("it-IT", { weekday: "short", day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });

export function CallbackButton({ p, onSaved }) {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ when: "", note: "" });
  useEffect(() => { if (open) setF({ when: p.callback_at || "", note: p.callback_note || "" }); }, [open, p]);
  const save = async (clear) => {
    try {
      await api.put(`/prospects/${p.id}/callback`, { callback_at: clear ? null : f.when, note: f.note });
      toast.success(clear ? "Richiamo rimosso" : "Richiamo impostato");
      setOpen(false); onSaved?.();
    } catch (e) { toast.error(e.response?.data?.detail || "Errore"); }
  };
  const quick = async (days) => {
    const d = new Date(); d.setDate(d.getDate() + days);
    const when = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}T10:00`;
    try { await api.put(`/prospects/${p.id}/callback`, { callback_at: when, note: p.callback_note || "" }); toast.success(`Richiamo: ${fmt(when)}`); onSaved?.(); }
    catch (e) { toast.error(e.response?.data?.detail || "Errore"); }
  };
  const chip = "text-[10px] uppercase tracking-widest px-2 py-1 rounded-full bg-sand text-stone hover:text-ink hover:bg-gold/30 transition-colors";
  return (
    <>
      <button onClick={() => quick(3)} className={chip} data-testid={`callback-3d-${p.id}`}>Tra 3 gg</button>
      <button onClick={() => quick(7)} className={chip} data-testid={`callback-7d-${p.id}`}>Tra 1 sett</button>
      <button onClick={() => setOpen(true)} data-testid={`callback-${p.id}`}
        className={`text-[10px] uppercase tracking-widest px-2 py-1 rounded-full transition ${p.callback_at ? "bg-gold/30 text-ink" : "bg-sand text-stone hover:text-ink"}`}>
        <Phone size={10} className="inline mr-1" />{p.callback_at ? fmt(p.callback_at) : "Richiama"}
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-canvas max-w-md" data-testid="callback-dialog">
          <DialogHeader><DialogTitle className="font-serif text-xl">Richiamare {p.property_name}</DialogTitle></DialogHeader>
          <input type="datetime-local" value={f.when} onChange={(e) => setF({ ...f, when: e.target.value })} className="w-full rounded-lg border border-line px-3 py-2 text-sm bg-canvas" data-testid="callback-when" />
          <input placeholder="Nota (es. chiedere della demo)" value={f.note} onChange={(e) => setF({ ...f, note: e.target.value })} className="w-full rounded-lg border border-line px-3 py-2 text-sm bg-canvas" data-testid="callback-note" />
          <div className="text-xs text-stone">Il giorno del richiamo, alle 8:00, ricevi un promemoria via email e WhatsApp.</div>
          <div className="flex justify-between">
            {p.callback_at ? <Button variant="outline" className="rounded-full" onClick={() => save(true)} data-testid="callback-clear">Rimuovi</Button> : <span />}
            <Button className="rounded-full bg-ink text-canvas" disabled={!f.when} onClick={() => save(false)} data-testid="callback-save">Salva</Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}

export function UpcomingCallbacks({ refreshKey }) {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/prospects/callbacks/upcoming").then((r) => setItems(r.data)).catch(() => {}); }, [refreshKey]);
  if (!items.length) return null;
  const today = new Date().toISOString().slice(0, 10);
  return (
    <div className="rounded-2xl border border-line bg-canvas p-4" data-testid="upcoming-callbacks">
      <div className="font-serif text-lg text-ink mb-2 flex items-center gap-2"><Phone size={18} />Prossimi richiami</div>
      <div className="flex flex-wrap gap-2">
        {items.slice(0, 12).map((p) => (
          <div key={p.id} className={`text-xs rounded-full px-3 py-1.5 border ${p.callback_at.slice(0, 10) <= today ? "border-terracotta text-terracotta" : "border-line text-ink"}`} data-testid={`upcoming-callback-${p.id}`}>
            <b>{fmt(p.callback_at)}</b> · {p.property_name}{(p.phone || p.whatsapp) && <> · <a href={`tel:${p.phone || p.whatsapp}`} className="underline">{p.phone || p.whatsapp}</a></>}
          </div>
        ))}
      </div>
    </div>
  );
}
